import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import styles from './Login.module.scss';

/**
 * Login component that displays a login form for protected routes
 */
const Login: React.FC = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login, isLoading } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    const result = await login(username, password);
    if (!result.success) {
      setError(result.error || 'Invalid username or password');
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className="bd-view-stagger">
      <div className={styles.loginCard}>
        <h1 className={styles.title}>Dashboard access</h1>
        <p className={styles.subtitle}>
          Sign in with the credentials you were given for this dashboard.
        </p>

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <label htmlFor="username">Username</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              autoComplete="username"
              disabled={isLoading}
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              autoComplete="current-password"
              disabled={isLoading}
              required
            />
          </div>

          {error ? (
            <div className={`${styles.error} bd-view-error-enter`} role="alert">
              {error}
            </div>
          ) : null}

          <button
            type="submit"
            className={`btn btn-primary w-100 ${styles.submitButton}`}
            disabled={isLoading}
          >
            {isLoading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
      </div>
    </div>
  );
};

export default Login;


